import { createAction, props } from '@ngrx/store';
import { RolloutWaitForCalculationData } from '../interfaces/rollout-quote-summary-data.interface';

export const loadRolloutQuote = createAction('[Rollout Wait For Calculation] loadRolloutQuote');
export const loadRolloutQuoteSuccess = createAction(
  '[Rollout Wait For Calculation] loadRolloutQuoteSuccess',
  props<{ quote: RolloutWaitForCalculationData }>()
);
export const loadRolloutQuoteError = createAction('[Rollout Wait For Calculation] loadRolloutQuoteError', props<{ error: string }>());
